import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../reducers";
import { ToastChange, Toastface } from "../../reducers/config";
import "./css/index.css";
function Toast() {
  const dispatch = useDispatch();
  const { active, content, type } = useSelector<RootState, Toastface>(
    (state) => state.config.toast
  );
  useEffect(() => {
    if (active) {
      setTimeout(() => {
        dispatch(ToastChange({ active: false, content: "" }));
      }, 2000);
    }

    return () => {};
  }, [active, dispatch, content]);

  return <div className={`toast ${active ? "toast-on" : ""} ${type && `${type}-toast`}`}>{content}</div>;
}

export default Toast;
